import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import AppContext from '../data/AppContext';
import ClaimEntryComponent from '../components/claim-entry.component';
import { SlIcon } from '@shoelace-style/shoelace/dist/react';
import Button from '../components/button.component';
import { useTranslation } from 'react-i18next';

const SingleEntry = () => {
  const { t } = useTranslation('app');
  const { voices, setActiveMountain } = useContext(AppContext);
  const { entryId } = useParams();

  const [entry, setEntry] = useState();

  useEffect(() => {
    const e = voices.find((v) => v.uuid === entryId);
    setEntry(e);
    if (e) {
      setActiveMountain(e.mountainId);
    }
    return () => setActiveMountain();
  }, [voices, entryId, setActiveMountain]);

  if (!entry) {
    return 'loading';
  }

  return (
    <>
      <Link to={'/'}>
        <Button>
          <SlIcon slot="prefix" name="arrow-left-short"></SlIcon>
          {t('entry.showAllEntries')}
        </Button>
      </Link>
      <ClaimEntryComponent claim={entry} />
    </>
  );
};

export default SingleEntry;
